export default __webpack_public_path__ + "static/media/phylosophytwo.81e93f0e.svg";